module.exports = __webpack_public_path__ + "img/smart-phone-light.51b488d4.svg";